import * as React from 'react';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import {Field, InjectedFormProps, reduxForm, reset} from 'redux-form';
import {Button, ButtonGroup} from 'reactstrap';
import renderSelectField from '../../../theme/components/form/Select';
import Panel from '../../../theme/components/Panel';
import {lazyInject, TYPES} from '../../../utils/inversify-config';
import MiranaServiceClient from '../../../middleware/mirana-client';
import {error} from '../../../utils/notification-actions';

interface PrioritariosFormState {
    mesas: mirana.MesaList;
    rutas: mirana.RutaList;
}

interface PrioritariosFormProps {
    fuerzaVentaId: string;
}

class PrioritariosForm extends React.PureComponent<InjectedFormProps & ReduxProps & PrioritariosFormProps, PrioritariosFormState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props) {
        super(props);

        this.state = {
            mesas: mirana.MesaList.create(),
            rutas: mirana.RutaList.create()
        };
        this.fetchMesas();
        this.fetchRutas();
    };


    private async fetchMesas() {
        try {
            const response = await this.apiClient.filtrarMesas(this.props.fuerzaVentaId);
            this.setState({mesas: response});
        } catch (ex) {
            this.props.dispatch(error('Error', 'Error al obtener mesas'));
        }
    }

    private async fetchRutas(mesaId?: string) {
        try {
            const response = await this.apiClient.filtrarRutas(this.props.fuerzaVentaId, mesaId);
            this.setState({rutas: response});
        } catch (ex) {
            this.props.dispatch(error('Error', 'Error al obtener vendedores'));
        }
    }

    private get mesaOptions() {
        const mesaList = this.state.mesas;
        const options = [
            {value: '', label: 'Todos'}
        ];
        if (mesaList.mesa) {
            mesaList.mesa.forEach((me) => {
                if (me.mesaId && me.descripcion) {
                    options.push({value: me.mesaId, label: me.descripcion});
                }
            });
        }
        return options;
    }

    private get rutaOptions() {
        const rutaList = this.state.rutas;
        const options = [
            {value: '', label: 'Todos'}
        ];
        if (rutaList.ruta) {
            rutaList.ruta.forEach((rt) => {
                if (rt.rutaId && rt.codigo) {
                    options.push({value: rt.rutaId, label: rt.codigo});
                }
            });
        }
        return options;
    }

    private handleMesaChange = (obj) => {
        this.fetchRutas(obj.value);
    };

    private handleReset = () => {
        this.props.dispatch(reset('prioritarios_form'));
        this.fetchMesas();
        this.fetchRutas();
    };

    public render() {
        const {handleSubmit} = this.props;

        return (
            <Panel xs={12} md={12} divider={true} title='Filtros'>
                <form className='form' onSubmit={handleSubmit}>
                    <div className='form__form-group'>
                        <label className='form__form-group-label'>Mesa </label>
                        <div className='form__form-group-field'>
                            <Field
                                name='mesaId'
                                component={renderSelectField}
                                placeholder='Todos'
                                onChange={this.handleMesaChange}
                                type='text'
                                options={this.mesaOptions}
                            />
                        </div>
                    </div>
                    <div className='form__form-group'>
                        <label className='form__form-group-label'>Vendedor </label>
                        <div className='form__form-group-field'>
                            <Field
                                name='rutaId'
                                component={renderSelectField}
                                placeholder='Todos'
                                type='text'
                                options={this.rutaOptions}
                            />
                        </div>
                    </div>
                    <ButtonGroup className='btn-group--justified'>
                        <Button color='success' type='submit'>GENERAR REPORTE</Button>
                    </ButtonGroup>
                    <ButtonGroup className='btn-group--justified'>
                        <Button outline={true} type='button' onClick={this.handleReset}>LIMPIAR</Button>
                    </ButtonGroup>
                </form>
            </Panel>
        )
    }
}

export default reduxForm({
    form: 'prioritarios_form', // a unique identifier for this form
})(PrioritariosForm);



// WEBPACK FOOTER //
// ./src/components/pages/prioritarios/prioritarios-form.tsx